<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="detailsWorkspace"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteWorkspace"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: "CellRendererActions",
    methods: {

        detailsWorkspace() {
            this.$router.push(`/user/workspace-setting-info?id=${this.params.data.id}`)
        },

        confirmDeleteWorkspace() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: 'Bạn có chắc là muốn xóa workspace này không?',
                accept: this.deleteWorkspace,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteWorkspace() {
            this.$vs.loading();
            this.$crm.post('/setting/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Xoá thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('DELETE_WORKSPACE_SUCCESS', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    }
}
</script>
